//Imports node_modules
import React, { useContext } from "react"

//Imports Css
import './OptionGroupBtn.css'

//Imports Components

//Import Data
import { globalFunctions } from '../../../data/GlobalFunctions'

//Este Botão foi principlamente feito para evitar duplo click, detetar micro deslizes de dedos, touch and click events
const OptionGroupBtn = (params) => {

    //--- Variaveis
    const {
        advancedClick,
    } = useContext(globalFunctions);

    const size = (params.operacao.size + 'px')

    return (
        <div
            className="btnMainLayout"
            key={params.operacao.text}
            onClick={e => advancedClick(e, (e => params.onClick(params.operacao)))}
            onTouchStart={e => advancedClick(e, (e => params.onClick(params.operacao)))}
            onTouchEnd={e => advancedClick(e, (e => params.onClick(params.operacao)))}
            onMouseDown={e => advancedClick(e, (e => params.onClick(params.operacao)))}
            onMouseUp={e => advancedClick(e, (e => params.onClick(params.operacao)))}
        >
            <div className="iconDiv" style={{backgroundColor: params.operacao.color}}>
                <img loading="lazy" src={params.operacao.icon} className='playsvg' style={{width: size , height: size}} alt=""/>
            </div>
            <div className="textDiv" style={{border: ('1.5px solid ' + params.operacao.color),}}>
                <p className="btnGroupText">
                    {params.operacao.text}
                </p>
            </div>
        </div>
    )
}

export default OptionGroupBtn